import { CHANGE_POLICY, CANCEL_POLICY, REINSTATE_POLICY } from 'customer/components/policy/policy.queries';
import { types as GQLTypes } from 'core/helpers/sanitize';
import { PolicyChangeAction } from 'core/helpers/policy-status';

/**
 * Maps a policy-change action to its dedicated preview mutation, GraphQL response key, and the
 * payload sanitizer for that mutation's input type (issues #31365 / #31966).
 *
 * Cancellation and reinstatement/rescind route to their first-class mutations, which take narrow
 * input types — so each returns its own sanitizer that keeps only that operation's fields. Every
 * other change (field edits, non-renewals, billing holds) stays on previewPolicyChangePolicy with
 * the full PolicyInput.
 */
export const getPreviewMutationForAction = (action) => {
  if (action === PolicyChangeAction.Cancel) {
    return {
      mutation: CANCEL_POLICY,
      previewKey: 'previewPolicyCancellation',
      sanitize: GQLTypes.PolicyCancellationInput
    };
  }
  if (action === PolicyChangeAction.Reinstate || action === PolicyChangeAction.Rescind) {
    return {
      mutation: REINSTATE_POLICY,
      previewKey: 'previewPolicyReinstatement',
      sanitize: GQLTypes.PolicyReinstatementInput
    };
  }
  return { mutation: CHANGE_POLICY, previewKey: 'previewPolicyChangePolicy', sanitize: GQLTypes.PolicyInput };
};
